import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../context/commandsContext';
import useKeyPress from '../../hooks/useKeyPress';
import FullBodyContentView from '../views/fullBodyContentView';

function SensorInfo({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit});
    });
  }, [onExit]);

  return (
    <FullBodyContentView
      title="Sensor Information"
      fullCaption="Sensor Model......0x18,.0x93........... 
      Serial Number.....0..........................
      Material...............MATERIAL...........
      Flange.................END.SPEC...............
      Liner....................LINER.SPEC...............
      "
    />
  );
}

export default SensorInfo;
